module.exports = __webpack_public_path__ + "img/argentina.9b7c1c7.webp";